module.exports = __webpack_public_path__ + "img/picto-tab-mental.457623f0.svg";